import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeTillages, getPracticeTillages } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_TILLAGES } from "consts";

import { PracticeTillage } from "models";

export const useGetPracticeTillages = ({ enabled }: { enabled?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getAdminPracticeTillages : getPracticeTillages;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((tillages: PracticeTillage[]) => injectNames(tillages, t, "tillages"), [t]);

  return useQuery({
    queryKey: [GET_PRACTICES_TILLAGES, enabled, isAdmin],
    queryFn: () => queryFn({ enabled }),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
